import { ElementType } from 'react';

import { LinkParams, FullscreenPreviewState, ClientRoom, Button, BehaviorState, UserState, WidgetSettings, NotificationType } from '../types';

export const TOGGLE_CHAT = 'BEHAVIOR/TOGGLE_CHAT';
export const TOGGLE_INPUT_DISABLED = 'BEHAVIOR/TOGGLE_INPUT_DISABLED';
export const TOGGLE_MESSAGE_LOADER = 'BEHAVIOR/TOGGLE_MSG_LOADER';
export const TOGGLE_CONNECTION_AWAIT = 'BEHAVIOR/TOGGLE_CONNECTION_AWAIT';
export const SET_BADGE_COUNT = 'BEHAVIOR/SET_BADGE_COUNT';
export const CHANGE_BUTTON_START_STATE = 'BEHAVIOR/CHANGE_BUTTON_START_STATE';
export const ADD_NEW_USER_MESSAGE = 'MESSAGES/ADD_NEW_USER_MESSAGE';
export const ADD_NEW_RESPONSE_MESSAGE = 'MESSAGES/ADD_NEW_RESPONSE_MESSAGE';
export const ADD_NEW_TRANSCRIPTION_MESSAGE = 'MESSAGES/ADD_NEW_TRANSCRIPTION_MESSAGE';
export const ADD_NEW_LINK_SNIPPET = 'MESSAGES/ADD_NEW_LINK_SNIPPET';
export const ADD_COMPONENT_MESSAGE = 'MESSAGES/ADD_COMPONENT_MESSAGE';
export const DROP_MESSAGES = 'MESSAGES/DROP_MESSAGES';
export const HIDE_AVATAR = 'MESSAGES/HIDE_AVATAR';
export const DELETE_MESSAGES = 'MESSAGES/DELETE_MESSAGES';
export const MARK_ALL_READ = 'MESSAGES/MARK_ALL_READ';
export const MARK_ERROR = 'MESSAGES/MARK_ERROR';
export const MARK_ACK = 'MESSAGES/MARK_ACK';
export const SET_QUICK_BUTTONS = 'SET_QUICK_BUTTONS';
export const OPEN_FULLSCREEN_PREVIEW = 'FULLSCREEN/OPEN_PREVIEW';
export const CLOSE_FULLSCREEN_PREVIEW = 'FULLSCREEN/CLOSE_PREVIEW';
export const ADD_CLIENT_ROOM_INFORMATION = 'CLIENT_ROOM/ADD_CLIENT_ROOM_INFORMATION';
export const UPDATE_USER_DATA = 'USER/UPDATE_USER_DATA';
export const SET_USER_AUTHORIZED = 'USER/SET_USER_AUTHORIZED';
export const SET_OPERATOR_PRINTING = 'BEHAVIOR/SET_OPERATOR_PRINTING';
export const UPDATE_WIDGET_SETTINGS = 'UPDATE_WIDGET_SETTINGS';
export const SHOW_NOTIFICATION = 'NOTIFICATION/SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'NOTIFICATION/HIDE_NOTIFICATION';

export interface ToggleChat {
  type: typeof TOGGLE_CHAT;
}

export interface ToggleInputDisabled {
  type: typeof TOGGLE_INPUT_DISABLED;
}

export interface AddUserMessage {
  messageId: string;
  type: typeof ADD_NEW_USER_MESSAGE;
  senderName: string;
  text: string;
  timestamp?: Date
  isAcknowledged: boolean
}

export interface AddResponseMessage {
  text: string;
  buttons: Button[],
  files: string[],
  senderName?: string,
  messageId: string;
  type: typeof ADD_NEW_RESPONSE_MESSAGE;
  timestamp?: Date
}

export interface AddTranscriptionMessage {
  type: typeof ADD_NEW_TRANSCRIPTION_MESSAGE;
  text: string;
  final?: boolean;
  id?: string;
  timestamp?: Date
}

export interface ToggleConnectionAwaiting {
  type: typeof TOGGLE_CONNECTION_AWAIT;
  status?: boolean;
}

export interface ToggleMsgLoader {
  type: typeof TOGGLE_MESSAGE_LOADER;
}

export interface AddLinkSnippet {
  type: typeof ADD_NEW_LINK_SNIPPET;
  link: LinkParams;
  id?: string;
}

export interface RenderCustomComponent {
  type: typeof ADD_COMPONENT_MESSAGE;
  component: ElementType;
  props: any;
  showAvatar: boolean;
  id?: string;
}

export interface DropMessages {
  type: typeof DROP_MESSAGES;
}

export interface HideAvatar {
  type: typeof HIDE_AVATAR;
  index: number;
}

export interface ChangeButtonStartState {
  type: typeof CHANGE_BUTTON_START_STATE;
  showStart: boolean;
}

export interface DeleteMessages {
  type: typeof DELETE_MESSAGES;
  count: number;
  id?: string;
}

export interface SetQuickButtons {
  type: typeof SET_QUICK_BUTTONS;
  buttons: Array<{ label: string, value: string | number }>;
}

export interface SetBadgeCount {
  type: typeof SET_BADGE_COUNT;
  count: number;
}

export interface MarkAllMessagesRead {
  type: typeof MARK_ALL_READ;
}

export interface MarkAck {
  type: typeof MARK_ACK;
  id: string;
}

export interface MarkError {
  type: typeof MARK_ERROR;
  id: string;
}

export interface UpdateUserDataState {
  type: typeof UPDATE_USER_DATA;
  userData: Partial<UserState['userData']>;
}

export interface SetUserAuthorizedState {
  type: typeof SET_USER_AUTHORIZED;
  isUserAuthorized: Partial<UserState['isUserAuthorized']>;
}

export interface SetOperatorPrinting {
  type: typeof SET_OPERATOR_PRINTING;
  isPrinting: boolean;
}

export interface UpdateWidgetSettingsAction {
  type: typeof UPDATE_WIDGET_SETTINGS;
  settings: WidgetSettings;
}

export type BehaviorActions = ToggleChat | ToggleInputDisabled | ToggleConnectionAwaiting | ToggleMsgLoader | ChangeButtonStartState | SetOperatorPrinting;

export type MessagesActions = AddUserMessage | AddResponseMessage | AddTranscriptionMessage | AddLinkSnippet | RenderCustomComponent
  | DropMessages | HideAvatar | DeleteMessages | MarkAllMessagesRead | SetBadgeCount | MarkAck | MarkError;

export type QuickButtonsActions = SetQuickButtons;

export type UserActions = UpdateUserDataState | SetUserAuthorizedState

export interface openFullscreenPreview {
  type: typeof OPEN_FULLSCREEN_PREVIEW;
  payload: FullscreenPreviewState
}

export interface closeFullscreenPreview {
  type: typeof CLOSE_FULLSCREEN_PREVIEW;
}

export interface addClientRoomInformation {
  type: typeof ADD_CLIENT_ROOM_INFORMATION;
  payload: ClientRoom
}

export type FullscreenPreviewActions = openFullscreenPreview | closeFullscreenPreview;

export type WidgetActions = UpdateWidgetSettingsAction;


export interface ShowNotificationAction {
  type: typeof SHOW_NOTIFICATION;
  payload: {
    message: string;
    type: NotificationType;
  };
}

export interface HideNotificationAction {
  type: typeof HIDE_NOTIFICATION;
}

export type NotificationActions = ShowNotificationAction | HideNotificationAction;

